import React from "react";
import { Button } from "@mui/material";
import styled from "@emotion/styled";

export default function LoginButton(props) {
    const LoginButton = styled(Button)({
        outline: "1px solid rgba(0,255,149,1)",
        borderRadius: "30px",
        transition: "0.5s",
        color: "black",
        fontFamily: "monospace",
        fontWeight: "bold",
        textTransform: "lowercase !important",
        "&:hover": {
            backgroundColor: "rgba(0,255,149,1)",
            color: "white",
        },
    });
    return <LoginButton {...props}>{props.children}</LoginButton>;
}
